import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter, NumberConverter } from '../../../inputConverter';
import { GisToolsService } from '../../../services/gis-tools.service';
import { IrowService } from '../../../services/irow.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var Point;
var SpatialReference;
var IrowComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IrowComponent, _super);
    function IrowComponent(_vcr, changeDetectorRef, irowService, gisToolsService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.irowService = irowService;
        _this.gisToolsService = gisToolsService;
        _this._active = false;
        _this._centerMapZoomLevel = 10;
        _this._enableAutoZoomLevel = true;
        _this._moveMapOnClick = true;
        _this.activeChange = new EventEmitter();
        _this.showSelect = false;
        _this.plansExist = false;
        _this.documentUrl = '';
        _this.options = {
            crsTolerance: 24
        };
        _this.county = '';
        _this.route = '';
        _this._segment = '';
        _this.tolerance = 100;
        //usecrsforirowbot checks if county, route and segment is provided as input for IROW bot. crs is county, route,segment.
        _this._usecrsforirowbot = false;
        _this.registerEvent('activeChange', _this.activeChange);
        return _this;
    }
    Object.defineProperty(IrowComponent.prototype, "active", {
        set: function (value) {
            this._active = BooleanConverter(value);
            this._active ? this.activate() : this.deactivate();
            this.activeChange.emit(this._active);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IrowComponent.prototype, "centerMapZoomLevel", {
        get: function () {
            return this._centerMapZoomLevel;
        },
        set: function (value) {
            this._centerMapZoomLevel = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IrowComponent.prototype, "enableAutoZoomLevel", {
        get: function () {
            return this._enableAutoZoomLevel;
        },
        set: function (value) {
            this._enableAutoZoomLevel = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IrowComponent.prototype, "moveMapOnClick", {
        set: function (value) {
            this._moveMapOnClick = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IrowComponent.prototype, "segment", {
        get: function () {
            return this._segment;
        },
        set: function (segment) {
            this._segment = segment;
            this.loadIrowSegment();
            this.changeDetectorRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IrowComponent.prototype, "usecrsforirowbot", {
        get: function () {
            return this._usecrsforirowbot;
        },
        set: function (value) {
            this._usecrsforirowbot = value;
        },
        enumerable: true,
        configurable: true
    });
    IrowComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        if (!!this._usecrsforirowbot) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapRef)];
                    case 1:
                        _a.mapRef = _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IrowComponent.prototype.loadIrowSegment = function () {
        if (this.usecrsforirowbot) {
            this.getSegmentDataForIROW();
            this.changeDetectorRef.detectChanges();
        }
    };
    IrowComponent.prototype.getSegmentDataForIROW = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.getSegmentData();
                this.showSelect = true;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Make the tool active/shown.
     */
    IrowComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadESRIClasses()];
                    case 1:
                        _a.sent();
                        if (!this.mapClickListener) {
                            this.mapClickListener = this.mapRef.on('click', function (evt) { return _this.handleMapClick(evt); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Make the tool inactive/hidden.
     */
    IrowComponent.prototype.deactivate = function () {
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
            this.mapRef.graphics.remove(this.pointGraphic);
        }
    };
    IrowComponent.prototype.loadESRIClasses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!Point || !Graphic || !SpatialReference)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                ESRI.Point,
                                ESRI.Graphic,
                                ESRI.SpatialReference
                            ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), Point = _a[0], Graphic = _a[1], SpatialReference = _a[2];
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IrowComponent.prototype.handleMapClick = function (evt) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!evt.mapPoint) return [3 /*break*/, 3];
                        this.selectedPoint = evt.mapPoint;
                        this.lat = this.selectedPoint.latitude;
                        this.long = this.selectedPoint.longitude;
                        return [4 /*yield*/, this.getCSR(this.lat, this.long)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getSegmentData()];
                    case 2:
                        _a.sent();
                        this.addPoint(this.selectedPoint.longitude, this.selectedPoint.latitude);
                        this.showSelect = true;
                        this.changeDetectorRef.detectChanges();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IrowComponent.prototype.getSegmentData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var irowPlans;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.segment) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([
                                this.irowService.getPlans(this.county, this.route, this.segment)
                            ])];
                    case 1:
                        irowPlans = _a.sent();
                        this.documentUrl = environment.apiBaseUrl + '/irow/planDocument';
                        this.irowPlans = irowPlans[0];
                        if (this.irowPlans[0] != undefined) {
                            this.plansExist = true;
                        }
                        else {
                            this.plansExist = false;
                        }
                        _a.label = 2;
                    case 2:
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    IrowComponent.prototype.getCSR = function (lat, long) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segments;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getSegmentsNearLatLong(lat, long, this.tolerance)];
                    case 1:
                        segments = _a.sent();
                        if (segments.length) {
                            this.county = segments[0].countyCode;
                            this.segment = segments[0].segmentNumber;
                            this.route = segments[0].stateRouteNumber;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IrowComponent.prototype.addPoint = function (long, lat) {
        if (this.mapRef) {
            if (this.pointGraphic) {
                this.mapRef.graphics.remove(this.pointGraphic);
            }
            var point = new Point({
                longitude: parseFloat(long),
                latitude: parseFloat(lat)
            });
            this.centerPoint = point;
            this.pointGraphic = new Graphic({
                geometry: point,
                symbol: this.pointSymbol
            });
            this.mapRef.graphics.add(this.pointGraphic);
            if (this._moveMapOnClick) {
                if (this.mapRef.zoom < this.centerMapZoomLevel && this.enableAutoZoomLevel) {
                    this.mapRef.goTo({
                        center: this.centerPoint,
                        zoom: this.centerMapZoomLevel
                    });
                }
                else {
                    this.mapRef.goTo({
                        center: this.centerPoint
                    });
                }
            }
            this.changeDetectorRef.detectChanges();
        }
    };
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], IrowComponent.prototype, "lat", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Number)
    ], IrowComponent.prototype, "long", void 0);
    return IrowComponent;
}(BaseComponent));
export { IrowComponent };
